(function ($) {
  function toTitleCase(str) {
    return str.toLowerCase().replace(/(?:^|\s)\w/g, function (match) {
      return match.toUpperCase();
    });
  }  

  function findInStr(string, search) {
    return string.indexOf(search) > -1;
  }

  var sendGoogleAnalyticsEvent = function (opts) {
    if (typeof ga != 'function') {
     // console.error('GA not defined');
      return false;
    }

    ga('send', {
      hitType: 'event',
      eventCategory: opts.category,
      eventAction: opts.action,
      eventLabel: opts.label,
      transport: 'beacon',
      nonInteraction: opts.noninteraction
    });
  }

  $('body').on('click', 'a, button.btn, button.drawer__close', function (e) {
    var sendGA = true,
        $this = $(this),
        sid = 'content',
        url = new window.URL($this.attr('href'), window.location.origin),
        href = url.href,
        opts = {
          category: "",
          action: "",
          label: "",
          noninteraction: false
        }; 
    
       var ammend="";
       if (window.themeOptions.template == "index"){
         ammend = "homepage";
       }else{
         ammend = window.themeOptions.handle;
       }
       
       switch ($this.closest('[data-section-id]').attr('data-section-id')) {
        case 'footer':
          sid = 'footer';
          break;
        case 'slide-nav':
          sid = 'slide-nav';
          break;
        case 'header':
          sid = 'header';
          break;
         case 'cart-drawer':
            sid = 'cart-drawer';
          break;
        default:
          sid = 'content';
          break;
      }
        //A REGULAR CLICK EVENT THEN
        opts.category = 'Engagement_Clicks';
  
        if (sid == 'footer' || sid == 'header' || sid=="slide-nav") {
          if ($this.closest('.slideout-nav').length > 0) {
            // is mobile header subnav
             opts.label = "SideNav";
            if ($this.closest('.slide-footer').length > 0){
              if ( $(this).text() != ""){
                
                  opts.action = ammend+"_Btn_"+ $(this).text().trim();
              }else{
                opts.action = ammend+"_"+ "Social Link";
              }
            }else{         
            opts.action = ammend+"_"+ $(this).text().trim();
                }
          } 
          else if ($this.closest('.page-header').length > 0) {
              if ($this.hasClass('is-logo')) {
                opts.label = "Header Click";
                opts.action = ammend+"_"+'Logo';
              } 
              else if ($this.closest('.mega-menu').length > 0) {
                if($this.hasClass("promo-link")){
                  opts.label = "Header Click: Shop Mega Menu";
                  opts.action = ammend+"_"+  "Promo Banner";
                }
                else{
                opts.label = "Header Click: Shop Mega Menu";
                opts.action = ammend+"_"+  $(this).text().trim();
                }
               }else if ($this.closest('.mini-menu').length > 0) {
                 opts.label = "Header Click: Learn More Drop";
                 opts.action = ammend+"_"+ $(this).text().trim();
               }
            else if ($this.hasClass("nav-trigger")) {
              opts.label = "Header Click: Top Level";
                 opts.action = ammend+"_"+ "Slide Menu Icon";
            }
            else if ($this.closest('.right-wrapper').length > 0) {
                if ($this.hasClass("account-icon")) {
                 opts.label = "Header Click: Top Level";
                 opts.action = ammend+"_"+ "Account Icon";
               }
             else if ($this.hasClass("site-header__cart")) {
                 opts.label = "Header Click: Top Level";
                 opts.action = ammend+"_"+ "Cart Icon";
               }
            }
            else{
                 opts.label = "Header Click: Top Level";
                 opts.action = ammend+"_"+ $(this).text().trim();
               }
          } 
         else if ($this.hasClass('footer-link')) {
            //is footer link
            var p = toTitleCase($this.closest('.section').find('.footer-title')[0].childNodes[0].nodeValue.trim());
            opts.label = "Footer Click";
            opts.action = ammend+"_"+ p + '_' +  $(this).text();
          } else {
            opts.action = ammend+"_"+ $(this).text(); 
          }
        }else if (sid == 'cart-drawer'){
          if ($this.hasClass('mini-minus')){
          opts.label = "Cart Drawer";
          opts.action = ammend+"_QuantityMinus";
          }else if ($this.hasClass('mini-plus')){
          opts.label = "Cart Drawer";
          opts.action = ammend+"_QuantityPlus";
          }else if ($this.hasClass('mini-sub')){
          opts.label = "Cart Drawer";
          opts.action = ammend+"_SubscriptionUpgrade";
          }
          
          else if ($this.hasClass('drawer__close')){
          opts.label = "Cart Drawer";
          opts.action = ammend+"_Close";
          } 
          else if ($this.hasClass('delete')){
          opts.label = "Cart Drawer";
          opts.action = ammend+"_Remove";
          } else if ($this.closest('.upsell-top').length > 0) {
            opts.label = "Cart Drawer: Upsell Top";
             opts.action = ammend+"_" + $this.closest('.upsell-top').find(".mini-title b").text().trim();            
          } else if ($this.closest('.upsell').length > 0) {
            opts.label = "Cart Drawer: Upsell";
             opts.action = ammend+"_" + $this.closest('.other-cart-item').find(".mini-title b").text().trim(); 
          } else{
             opts.label = "Cart Drawer";
             opts.action = ammend+"_"+ $(this).text().trim();
          }
        }
        else if (window.themeOptions.template == "index") {
          opts.action = 'Homepage_click';
          let trackingLabel = $(this).data("tracking");
          if(!trackingLabel) {
            if($(this).closest("[data-tracking]")) {
              trackingLabel = $(this).closest("[data-tracking]").data("tracking");
            }
          }
          if(trackingLabel) {
            opts.label = trackingLabel;
          } else if ($(this).parents('.shopify-section').attr('id') == "shopify-section-1619033416f37fd51d" || $(this).parents('.shopify-section').attr('id') == "shopify-section-165271409225d17d20"){
             if ( $(this).text().length > 0){
            opts.label = "Hero CTA: "+ $(this).text(); 
             }else{
               opts.label = "Hero CTA: Image"; 
             }
          }
           else if ($(this).parents('.shopify-section').attr('id') == "shopify-section-16527281709f46694d"){
             if ( $(this).text().length > 0){
            opts.label = "Quiz CTA: "+ $(this).text(); 
             }else{
               opts.label = "Quiz CTA: Image"; 
             }
          }
          else if ($(this).parents('.shopify-section').attr('id') == "shopify-section-1628525719f532c5e5"){ 
             if($(this).parents('.modal-wrapper').length > 0){
                 opts.label = "QUICK VIEW: " +$(this).text();
             }
             else{
                opts.label = "COLLECTIONS MODULE: " +$(this).text();
             }
           }

          else if ($(this).parents('.shopify-section').attr('id') == "shopify-section-1619033716085f758d"){
            opts.label = "Grid Block CTA Click";
          }
          else if ($(this).parents('.shopify-section').attr('id') == "shopify-section-16190337471616c42a"){
            opts.label = "Discover Full Collection CTA Click";
          }
          else if ($(this).parents('.shopify-section').attr('id') == "shopify-section-161903357378e6934d"){
            opts.label = "Logo Slider CTA Click";
          }
           else if ($(this).closest('.shopify-section.show-on-scroll').length > 0){
             opts.label = "Row:" +$(this).text();
          }
         // alert( opts.label);

        }
       
       var device="";
       if (window.screen.width > 768){
         device = "Deskop";
       }
       else{
         device = "Mobile";
       }

      if (opts.category == '' || opts.action == '') {
        
        //console.log('++ ignore event final', opts);
        sendGA = false;
      } else {
        opts.category = device +"_"+ opts.category
        console.log(opts);
        sendGoogleAnalyticsEvent(opts);
      }
  });

  // on add to cart
  $('[data-add-to-cart]').on('click', function () {
    
     var device="";
       if (window.screen.width > 768){
         device = "Deskop";
       }
       else{
         device = "Mobile"
       }
    var ammend="";
    if(window.themeOptions.template == "list-collections"){
         ammend = "shop all-";
       }
    
    var onetime = $(this).closest(".product-form").find(".recharge-radio-container input:checked").val();
    var dropdown = $(this).attr('data-add-to-cart');
    sendGoogleAnalyticsEvent({
      category: device+'_Conversion_AddToCart',
      action: ammend + dropdown + "_" + onetime,
      label: window.themeOptions.page_title,
      noninteraction: true
    });
  });

})(jQuery);